import { isNil } from "lodash";

// React key for a producer report row, per report view.
//
// None of the three views offers a unique business key: the report-item endpoint returns no `id`, and
// the data contains rows sharing user + cycle + plan with different playback points and revenue. So the
// position in the list is what makes the key unique, with the business fields in front to keep it
// legible when debugging.
//
// The index is safe here because the grid data array is append-only for the lifetime of a rendered
// list: paging appends, while a filter, sort or view change replaces the data wholesale and re-renders
// everything anyway.
//
// Uniqueness matters rather than being cosmetic — React drops or merges colliding siblings, so a
// duplicate key makes the view render fewer rows than the report contains while the summary panel still
// counts them all, which presents as the view failing to reconcile when the figures are correct.
export const reportViewIds = {
    listeners: 0,
    content: 1,
    tracks: 2,
};

export default function generateReportRowKey(reportViewId, item, index) {
    if (isNil(item)) {
        return `row_${index}`;
    }

    if (reportViewId === reportViewIds.content) {
        return `${item.contentId}_${index}`;
    }

    if (reportViewId === reportViewIds.tracks) {
        return `${item.trackId}_${index}`;
    }

    return `${item.userId}_${item.subscriptionCycleStartDate}_${index}`;
}
